import {
  REQUEST_FORM_FIELD_NAME_APPLICANT,
  REQUEST_FORM_FIELD_NAME_BUILDING,
} from '../../RequestForm.constants'

export function getFlatApiParams(values, isStaff) {
  return {
    building: values[REQUEST_FORM_FIELD_NAME_BUILDING]?.value,
    inhabitant: isStaff
      ? null
      : values[REQUEST_FORM_FIELD_NAME_APPLICANT]?.value,
  }
}
